/**
 * PoNumberFieldButton - PO Number field button using existing hooks
 */

import {usePoNumber} from '@hconnect/tuc-processes/fields/textField'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {getTranslatedErrorMessage} from '../../../../../orderIntake'
import {FieldButton} from '../../FieldButton'

interface PoNumberFieldButtonProps {
  onClick: () => void
  requiresApproval?: boolean
  isReadOnly?: boolean
  isChanged?: boolean
}

export const PoNumberFieldButton: React.FC<PoNumberFieldButtonProps> = ({
  onClick,
  requiresApproval = false,
  isReadOnly = false,
  isChanged = false
}) => {
  const {t} = useTranslation()
  const {poNumber, error} = usePoNumber()

  // Following useRmcOrderEditLogic withFallback pattern
  const trimmed = poNumber?.toString().trim()
  const displayValue = trimmed && trimmed.length > 0 ? trimmed : null

  return (
    <FieldButton
      label={t('orderIntake.rmc.orderManagement.editSteps.labels.poNumber', 'PO number')}
      value={displayValue}
      onClick={onClick}
      requiresApproval={requiresApproval}
      isReadOnly={isReadOnly}
      isChanged={isChanged}
      error={getTranslatedErrorMessage(error, t)}
    />
  )
}
